import React from "react";
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";
import AxiosIndicatorRunTimeLoader from "../AxiosIndicatorRunTimeLoader";

const Other = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const { otherContentList, searchText, apiCall } = props;

  const typeHeadSearchEvent = (obj) => {
    HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Other", obj?.name, obj?.url)
  }
  return (
    <>

      <div className="search-item-title text-uppercase">OTHER CONTENT</div>
      {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Other ?
        <AxiosIndicatorRunTimeLoader />
        : <>
          {Object.keys(otherContentList).length > 0 ? (
            <>
              <div className="search-artical-list">
                {Object.keys(otherContentList).length > 0 &&
                  Object.entries(otherContentList).map((v, i) => (
                    <React.Fragment key={i}>
                      {i < 5 && (
                        <div className="search-artical-list-item">
                          <div className="search-artical-list-item-info">
                            <a
                              onClick={() => typeHeadSearchEvent(v[1])}
                              href={v[1].url}
                              className=" cursor-pointer"
                            >
                              <div className="search-artical-title">{v[1].name}</div>
                            </a>
                            <div className="search-artical-desc">
                              {v[1].shortDescription}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
              </div>
              <a
                href={
                  HomePage.makeHomeTabsListRouteURL(
                    CommonHomePageContent.chain_HomeTabList.CNT.param_value
                  ) +
                  "&__c_HomePageContent=ALCT&__c_HomePageContentTabList=OTR&search=" +
                  searchText +
                  "&viewAll=true"
                }
                className="text-center mt-auto pb-3 pt-3"
              >
                <div className="bs5 btn btn-sm btn-primary">VIEW ALL Results</div>
              </a>
            </>
          ) :
            <NoContent />
          }

        </>
      }
    </>
  );
};

export default Other;
